import { useCallback, useEffect, useMemo } from 'react';
import { RecentlyViewedService } from 'RecentlyViewedService';

/**
 * Hook to track model views for admin users
 * Admin-only hook - only available in admin builds
 */
export const useRecentlyViewed = () => {
  const recentlyViewedService = useMemo(() => {
    return RecentlyViewedService.getInstance();
  }, []);

  /**
   * Track a model view
   */
  const trackView = useCallback(
    (modelType: string, modelId: string) => {
      recentlyViewedService.trackModelView(modelType, modelId);
    },
    [recentlyViewedService],
  );

  /**
   * Get recently viewed items
   */
  const getRecentlyViewed = useCallback(
    async (modelType?: string, limit?: number, page?: number) => {
      return await recentlyViewedService.getRecentlyViewed(modelType, limit, page);
    },
    [recentlyViewedService],
  );

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      recentlyViewedService.clearPendingRequests();
    };
  }, [recentlyViewedService]);

  return {
    trackView,
    getRecentlyViewed,
  };
};

export default useRecentlyViewed;
